import { useEffect, useState } from 'react';
import dayjs from 'dayjs';

/**
 * Custom hook that returns true if the current date is between June 30th and July 5th (inclusive)
 * Useful for displaying special content during the 4th of July period
 */
export const useUSALogo = (): boolean => {
  const [showUSALogo, setShowUSALogo] = useState<boolean>(false);

  useEffect(() => {
    const checkDateRange = () => {
      const now = dayjs();
      const currentYear = now.year();

      const startDate = dayjs().year(currentYear).month(5).date(30);
      const endDate = dayjs().year(currentYear).month(6).date(5);

      const isInRange =
        (now.isAfter(startDate) || now.isSame(startDate)) && (now.isBefore(endDate) || now.isSame(endDate));

      setShowUSALogo(isInRange);
    };

    checkDateRange();

    const interval = setInterval(checkDateRange, 24 * 60 * 60 * 1000);

    return () => clearInterval(interval);
  }, []);

  return showUSALogo;
};

export default useUSALogo;
